var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoumoniPartnerEnea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183,
    height: 35.969,
    viewBox: "0 0 183 35.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a9001e",
    id: "logo",
    className: "cls-1",
    d: "M532.77,105.95h3.212c-2.179-3.666-6.274-17.033-11.155-35.927l-15.17.005-23.924,35.947H498.94l3.506-5.84h16.167l0.952,5.84h16.424v-0.022h-3.217ZM506.858,92.681l8.226-13.806h0.1l2.158,13.806H506.858ZM461.63,98.219l1.424-6.49h23.161l1.627-7.453H464.68l1.425-6.5h24.713L492.513,70l-37.1.007-0.014.059c-4.86,18.825-8.945,32.155-11.118,35.834h0V105.9l0,0.01h0v0.016h-0.026v0.039h3.351v0.009h37.047l1.694-7.758H461.63ZM438.071,70.03l-4.92,22.5h-0.1l-12.23-22.5-14.377-.011c-4.877,18.873-8.968,32.23-11.141,35.894h3.47v0.006h-3.48v0.029h3.477l0,0h-3.491v0.029h3.656v-0.006h11.746l4.969-22.707h0.1L428.5,105.974h13.627l7.869-35.944H438.071ZM370.559,98.219l1.423-6.493h23.155l1.633-7.45H373.611l1.419-6.493h24.716l1.695-7.751H364.153c-4.88,18.894-8.98,32.28-11.157,35.953h3.547l0-.007h37.031l1.7-7.757H370.559Z",
    transform: "translate(-353 -70)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoumoniPartnerEnea);
export default __webpack_public_path__ + "static/media/youmoni-partner-enea.6b6450ec0538be1756d5e22fc12637e6.svg";
export { ForwardRef as ReactComponent };